export default __webpack_public_path__ + "static/media/legalchile.ce4bce1b.svg";